import React, { type CSSProperties, type ReactNode } from 'react';
import { connect } from 'react-redux';

import { Wrapper, Left, Right } from './elements';

export type HeaderProps = {
  left?: ReactNode;
  right?: ReactNode;
  sidebarOpened?: boolean;
  className?: string;
  style?: CSSProperties;
};

export const Header = ({
  left,
  right,
  style,
  className,
  sidebarOpened
}: HeaderProps) => (
  <Wrapper style={style} className={className}>
    <Left style={{ paddingLeft: !sidebarOpened ? 40 : 0 }}>{left}</Left>
    <Right>{right}</Right>
  </Wrapper>
);

export default connect((state: any) => ({
  sidebarOpened: state.sidebar.opened
}))(Header);
